import { ApolloLink, from, HttpLink, InMemoryCache } from 'apollo-boost';
import { ApolloClient } from 'apollo-client';
import Vue from 'vue';
import VueApollo from 'vue-apollo';

import { Storage } from './enums/storage.enum';
import router from './router';
import { UNAUTHORIZED_MESSAGES } from './utils/constants';

Vue.use(VueApollo);

const httpLink = new HttpLink({ uri: process.env.VUE_APP_API_URL });

const tokenApplyMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    const token = localStorage.getItem(Storage.TOKEN);
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      });
    }
    return forward(operation);
  }
  return null;
});

const tokenRefreshMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      const context = operation.getContext();
      const headers = context.response.headers;
      if (headers) {
        const newToken = headers.get('token');
        if (newToken) {
          localStorage.setItem(Storage.TOKEN, newToken);
        }
      }

      return response;
    });
  }
  return null;
});

const unauthorizedMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      if (
        response.errors &&
        response.errors.some(graphQlError => UNAUTHORIZED_MESSAGES.includes(graphQlError.message))
      ) {
        localStorage.clear();
        router.push({ name: 'login' });
      }

      return response;
    });
  }
  return null;
});

export const apolloClient = new ApolloClient({
  link: from([unauthorizedMiddleware, tokenApplyMiddleware, tokenRefreshMiddleware, httpLink]),
  cache: new InMemoryCache({ resultCaching: false })
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
